// extracted by mini-css-extract-plugin
export default {"greenBlockContainer":"styles_greenBlockContainer__Ko+zQ","whiteBorder":"styles_whiteBorder__d+7QQ","greenBlock":"styles_greenBlock__2iLTS"};